import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { DepartmentService } from "../../_services/department.service";

@Component({
  selector: "app-department-tree",
  templateUrl: "./departments.component.html",
  styleUrls: ["./departments.component.scss"],
})
export class DepartmentTreeComponent implements OnInit {
  constructor(private departmentService: DepartmentService) {}

  public AllowParentSelection = true;
  public RestructureWhenChildSameName = true;
  public ShowFilter = true;
  public Disabled = false;
  public FilterPlaceholder = "Tìm kiếm theo tên phòng ban";
  public MaxDisplayed = 500;
  @Output() changeDepartment = new EventEmitter();
  @Input() simpleSelected: any;
  @Input() multipleSelected: any;
  @Input() checkMultiple: boolean;

  select() {
    this.changeDepartment.emit(this.simpleSelected);
  }
  selectMultiple() {
    this.changeDepartment.emit(this.multipleSelected);
    setTimeout(() => {
      $(".pull-left.selected-item-item.btn.btn-default.btn-xs").css({
        border: "1px solid rgba(145, 142, 142, 0.52)",
        color: "black",
      });
      $(".close").css({ "padding-top": "0px", color: "red" });
    }, 100);
  }
  public departments: Array<any>;
  ngOnInit(): void {
    this.getDepartments();
  }
  getDepartments() {
    this.departmentService.index().subscribe((response) => {
      if (response.success) {
        this.departments = response.data.departments;
        this.departments = this.unflatten(this.departments);
      }
    });
  }
  unflatten(arr) {
    var tree = [],
      mappedArr = {},
      arrElem: any,
      mappedElem: any;

    if (!this.checkMultiple) {
      tree.push({ _id: -999, name: "--- Chọn ---" });
    }
    for (var i = 0; i < arr.length; i++) {
      arrElem = arr[i];
      mappedArr[arrElem._id] = arrElem;
      mappedArr[arrElem._id]["children"] = [];
    }
    for (var _id in mappedArr) {
      if (mappedArr.hasOwnProperty(_id)) {
        mappedElem = mappedArr[_id];
        if (mappedElem.parent) {
          if (mappedArr[mappedElem["parent"]]) {
            mappedArr[mappedElem["parent"]]["children"].push(mappedElem);
          }
        } else {
          tree.push(mappedElem);
        }
      }
    }
    return tree;
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/department-tree/departments.component.ts